// @flow

import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';

import store from './common/store';
import mainTheme from './themes/mainTheme';
import Main from './Main.js';
import IEBlockedScreen from './screens/IEBlockedScreen';
import { isIE } from './utils/Utils';

export default function App() {
  if (isIE()) {
    return <IEBlockedScreen />;
  }

  return (
    <Provider store={store}>
      <ThemeProvider theme={mainTheme}>
        <Main />
      </ThemeProvider>
    </Provider>
  );
}
